import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { IPartner } from 'clickNgo/entities/partner/models'
import { I406Form } from 'clickNgo/models/crud/forms/i406Form'

export const map406FromPartner = (partner: Partial<IPartner>): Partial<I406Form> => {
  return {
    AddressLine1: partner.addressLine1,
    AddressLine2: partner.addressLine2,
    AddressLine3: partner.addressLine3,
    City: partner.city,
    CommunicationName: partner.communicationName,
    CompanyEnglishName: partner.companyEnglishName,
    Country: partner.country,
    Email: partner.email,
    EntryId: partner.entryId406 || partner.entryId,
    Hierarchy: partner.hierarchyType,
    LocationID: partner.locationId,
    MainPhone: partner.phone,
    MainPhoneCountryCode: partner.phoneCountryCode,
    Market: partner.market,
    ModifiedValues: partner.modifiedValues?.join(',') || '',
    PartnerID: partner.partnerId,
    ProfileApproverComment: partner.approverComment,
    ProfileTeamComment: partner.profileTeamComment,
    Source: partner.source || ProfilingRequestSource.ClickAndGo,
    SourceRequestor: partner.sourceRequester,
    State: partner.state,
    Status: partner.status,
    StoreNumber: partner.storeNumber,
    TaxID: partner.taxId,
    TopPartnerID: partner.topPartnerId,
    URL: partner.url,
    WorkflowStatus: partner.workflowStatus,
    ZIPCode: partner.zipCode,
    OnboardingRequestId: partner.onboardingRequestId,
  }
}
